// extracted by mini-css-extract-plugin
module.exports = {"control":"styles_control__VDZB3","label":"styles_label__4DP8w","item":"styles_item__310cT","content":"styles_content__nAmTp"};